import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ListSessioniOlaDTO, SessioneOlaDTO } from 'src/app/model/newModel';
import { SelectDTO } from '../../../model/newModel';
import { ConstantsCLA } from '../../../shared/constants-cla';
import { AddUpdateSessioneOlaCommand } from 'src/app/model/command-model';
import {
  EliminaCommand,
  GetCommand,
  SearchSessioneOlaCommand,
} from '../../../model/command-model';

@Injectable({
  providedIn: 'root',
})
export class ASessioneOlaService {
  constructor(private http: HttpClient) {}

  convertMese(numeroMese: number): string {
    const meseFound = this.getMesi().filter(
      (mese: SelectDTO) => mese.value === '' + numeroMese
    )[0];

    return meseFound ? meseFound.viewValue : '';
  }

  save(newSessioneOla: AddUpdateSessioneOlaCommand) {
    return this.http.post<AddUpdateSessioneOlaCommand>(
      ConstantsCLA.CREA_SESSIONE_OLA_URL,
      newSessioneOla
    );
  }

  eliminaSessione(idSessioneOla: number) {
    const command = new EliminaCommand();
    command.id = idSessioneOla;
    return this.http.post<Boolean>(
      ConstantsCLA.ELIMINA_SESSIONE_OLA_URL,
      command
    );
  }

  update(updateSessioneOla: AddUpdateSessioneOlaCommand) {
    return this.http.post<AddUpdateSessioneOlaCommand>(
      ConstantsCLA.MODIFICA_SESSIONE_OLA_URL,
      updateSessioneOla
    );
  }

  rimuoviDocumento(idDocumento: number) {
    const command = new EliminaCommand();
    command.id = idDocumento;
    return this.http.post<Boolean>(
      ConstantsCLA.RIMUOVI_DOCUMENTO_SESSIONE_OLA_URL,
      command
    );
  }

  getAnni() {
    const anni: SelectDTO[] = [];
    const currentDate = new Date();
    currentDate.setFullYear(currentDate.getFullYear() - 5);
    const currentLastFiveYear = currentDate.getFullYear();
    for (let i = 0; i <= 15; i++) {
      const anno: SelectDTO = new SelectDTO();
      anno.value = '' + (currentLastFiveYear + i);
      anno.viewValue = '' + (currentLastFiveYear + i);
      anni.push(anno);
    }
    return anni;
  }

  getMesi() {
    const mesi: SelectDTO[] = [];
    const gennaio: SelectDTO = new SelectDTO();
    gennaio.value = '1';
    gennaio.viewValue = 'GENNAIO';
    const febbraio: SelectDTO = new SelectDTO();
    febbraio.value = '2';
    febbraio.viewValue = 'FEBBRAIO';
    const marzo: SelectDTO = new SelectDTO();
    marzo.value = '3';
    marzo.viewValue = 'MARZO';
    const aprile: SelectDTO = new SelectDTO();
    aprile.value = '4';
    aprile.viewValue = 'APRILE';
    const maggio: SelectDTO = new SelectDTO();
    maggio.value = '5';
    maggio.viewValue = 'MAGGIO';
    const giugno: SelectDTO = new SelectDTO();
    giugno.value = '6';
    giugno.viewValue = 'GIUGNO';
    const luglio: SelectDTO = new SelectDTO();
    luglio.value = '7';
    luglio.viewValue = 'LUGLIO';
    const agosto: SelectDTO = new SelectDTO();
    agosto.value = '8';
    agosto.viewValue = 'AGOSTO';
    const settembre: SelectDTO = new SelectDTO();
    settembre.value = '9';
    settembre.viewValue = 'SETTEMBRE';
    const ottobre: SelectDTO = new SelectDTO();
    ottobre.value = '10';
    ottobre.viewValue = 'OTTOBRE';
    const novembre: SelectDTO = new SelectDTO();
    novembre.value = '11';
    novembre.viewValue = 'NOVEMBRE';
    const dicembre: SelectDTO = new SelectDTO();
    dicembre.value = '12';
    dicembre.viewValue = 'DICEMBRE';

    mesi.push(gennaio);
    mesi.push(febbraio);
    mesi.push(marzo);
    mesi.push(aprile);
    mesi.push(maggio);
    mesi.push(giugno);
    mesi.push(luglio);
    mesi.push(agosto);
    mesi.push(settembre);
    mesi.push(ottobre);
    mesi.push(novembre);
    mesi.push(dicembre);
    return mesi;
  }

  getSessioneOla(idSessioneOla: number) {
    const command = new GetCommand();
    command.id = idSessioneOla;
    return this.http.post<SessioneOlaDTO>(
      ConstantsCLA.GET_SESSIONE_OLA_URL,
      command
    );
  }

  search() {
    const command = new SearchSessioneOlaCommand();
    return this.http.post<ListSessioniOlaDTO>(
      ConstantsCLA.SESSIONI_OLA_SEARCH_URL,
      command
    );
  }
}
